var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 70 67"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m24.17 20.78 8.573-17.319c1.1-2.223 4.28-2.223 5.38 0l8.574 17.32 19.173 2.794c2.46.358 3.44 3.374 1.66 5.103L53.658 42.15l3.274 19.032c.42 2.444-2.153 4.308-4.354 3.153l-17.145-8.99-17.145 8.99c-2.201 1.155-4.774-.71-4.354-3.153l3.274-19.032L3.337 28.678c-1.781-1.73-.8-4.745 1.66-5.103z"
})));
export default SvgStar;